import React from 'react'

export const NoMatch = () => (
    <div>
        <h1>No match</h1>
    </div>

)